<template>
  <a-card :bordered="false">

    <!-- 模块展示 -->
    <div class="module-wrapper">
      <div class="module-box" v-for="n in 5" :key="n" @click="openDetail(n)">
        <template v-if="playlistMap[n]">
          模块 {{ n }}
          <div v-for="item in playlistMap[n]?.slice().sort(languageSorter)" :key="item.id">
            {{ item.name }}
          </div>
        </template>
        <template v-else>
          模块 {{ n }}（暂无数据）
        </template>
      </div>

    </div>

    <!-- 抽屉中的详情组件 -->
    <a-drawer placement="right" :key="currentType" :visible="drawerVisible" :width="'80%'" @close="drawerVisible = false"
      :maskClosable="false" :keyboard="false">
      <!-- 使用 slot 插入动态标题 -->
      <template #title>
        模块{{ currentType }}
      </template>
      <Details :type="currentType"/>
    </a-drawer>

    <!-- 原有的新增弹窗组件 -->
    <create-form ref="Details" />
  </a-card>
</template>
  
<script>
import { getPlaylist } from '@/api/video/video'
import Details from './modules/Details'
import { tableMixin } from '@/store/table-mixin'
import CreateForm from './modules/CreateForm.vue'

export default {
  name: 'Push',
  components: {
    Details,
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      playlistMap: {},
      selectedRowKeys: [],
      selectedRows: [],
      drawerVisible: false,
      currentType: null,
      drawerVisible: false,
      columns: [
        // ...你的表格列配置
      ]
    }
  },
  methods: {
    languageSorter(a, b) {
      const order = ['zh', 'en', 'ja', 'id', 'pt', 'es']
      return order.indexOf(a.language) - order.indexOf(b.language)
    },
    openDetail(type) {
      this.currentType = type
      this.drawerVisible = true
    },
    getList() {
      getPlaylist().then(response => {
        const map = {}
        const data = response.data || []
        data.forEach(item => {
          const type = item.type
          if (!map[type]) {
            map[type] = []
          }
          map[type].push(item)
        })
        this.playlistMap = map
        console.log(this.playlistMap)
      })
    }

  },
  created() {
    this.getList();
  },
  computed: {
  }
}
</script>
  
<style scoped>
.module-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0;
}

.module-box {
  padding: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #f9f9f9;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s;
}

.module-box:hover {
  background: #e6f7ff;
  border-color: #91d5ff;
}
</style>
  